import React from 'react';
// import withScrollFade from './withScrollFade';

class GridImage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {isVisible: false};

        this.viewportObserver = null;
        this.img = React.createRef();
    }

    componentDidMount() {
        this.viewportObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if(entry.isIntersecting) {
                    this.enter();
                    this.viewportObserver.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.2,
            rootMargin: '0px 0px 0px 0px'
        });

        this.viewportObserver.observe(this.img.current);
    }

    componentWillUnmount() {
        if(this.viewportObserver) {
            this.viewportObserver.disconnect();
        }
    }

    enter() {
        this.setState({isVisible: true});
    }

    render() {
        return (
            <img ref={this.img} className={`${this.props.params.className} ${((this.state.isVisible) ? 'visible' : '')}`} src={this.props.params.asset.medium[1].src} srcSet={`${this.props.params.asset.medium[1].src} ${this.props.params.asset.medium[1].width}w, ${this.props.params.asset.medium[0].src} ${this.props.params.asset.medium[0].width}w, ${this.props.params.asset.large[1].src} ${this.props.params.asset.large[1].width}w, ${this.props.params.asset.large[0].src} ${this.props.params.asset.large[0].width}w`} sizes={this.props.params.sizes} alt=""/>
        );
    }
}

export default GridImage;


// WEBPACK FOOTER //
// ./src/components/GridImage.js